import {
  REQUEST_PEER_REVIEW,
  RESPONSE_PEER_REVIEW,
  FAILURE_PEER_REVIEW,
  SET_EMPTY_KEYWORDS,
  SET_UPDATE_KEYWORDS,
  SET_ABSTRACT_FROM_FILE,
  SET_UPDATE_SELECTED_KEYWORDS
} from "../../actions/types";

const initialState = {
  keyword: "",
  isFetching: false,
  keywords: [],
  selectedKeywords: [],
  abstract: "",
  error: false,
  isInitalScreen: true
};

const setFetching = (state, action) => {
  return {
    ...state,
    isFetching: true,
    results: [],
    isInitalScreen: false
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    keywords: [],
    abstract: ""
  };
};

const setEmptyKeywords = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: false,
    keywords: [],
    abstract: ""
  };
};

const setAbstractFromFile = (state, action) => {
  let abstract = action.payload.results;
  return {
    ...state,
    isFetching: false,
    error: false,
    keywords: [],
    abstract: abstract
  };
};

const setUpdateKeywords = (state, action) => {
  let keywords = action.payload.keywords || [];
  // let abstract = action.payload.abstract;

  return {
    ...state,
    isFetching: false,
    error: false,
    keywords
    // abstract
  };
};

const setUpdateSelectedKeywords = (state, action) => {
  let selectedKeywords = action.payload.selectedKeywords || [];
  // let abstract = action.payload.abstract;

  return {
    ...state,
    isFetching: false,
    error: false,
    selectedKeywords
    // abstract
  };
};

const setResults = (state, action) => {
  let keywords = action.payload.keywords || [];
  let abstract = action.payload.abstract;

  return {
    ...state,
    isFetching: false,
    error: false,
    keywords,
    abstract
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_PEER_REVIEW:
      return setFetching(state, action);
    case RESPONSE_PEER_REVIEW:
      return setResults(state, action);

    case SET_EMPTY_KEYWORDS:
      return setEmptyKeywords(state, action);

    case SET_UPDATE_KEYWORDS:
      return setUpdateKeywords(state, action);

    case SET_UPDATE_SELECTED_KEYWORDS:
      return setUpdateSelectedKeywords(state, action);

    case SET_ABSTRACT_FROM_FILE:
      return setAbstractFromFile(state, action);

    case FAILURE_PEER_REVIEW:
      return setFailure(state, action);

    default:
      return state;
      break;
  }
};
